<template>
  <div>
    <div class="h-topo_tlbox_click" v-show="showFirstIcon">
      <div class="h-topo_tltop_click">
        <span @click="clickNetType" class="e-btn-icon icon hero-icon hero-icon-Expand-lr"></span>
      </div>
    </div>
    <div class="h-topo_tlbox" v-show="showNetType">
      <div class="h-topo_tltop">
        {{$t('Topo.netTypeImg')}}
        <div class="h-topo_tlicon" @click="clickNetType">
          <span class="e-btn-icon icon hero-icon hero-icon-Expand-lr"></span>
        </div>
      </div>
      <div class="h-topo_tlbottom" style="overflow-x: auto">
        <table class="h-topo_tlheight">
          <div v-for="(item,i) in list" :key="i">
            <tr>
              <td>
            
                <span :class="['icon hero-icon '+item.icon]" style="color:#0ea1e5"></span>
                <span class="topo-tlline">{{item.nameKey}}</span>
              </td>
            </tr>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NetTypeShow',

  data() {
    // 	overflow-x: scroll; 
    // white-space: nowrap;
    return {
      list: [],
      showNetType: false,
      showFirstIcon: true
    };
  },
      scrollSettings: {
        canAutoScroll: true,
        scrollLimit: 'Diagram',
        horizontalOffset: 0,
        verticalOffset: 0,
        currentZoom: 1,
        maxZoom: 1.2,
        minZoom: 0.1,
      },

  props: {
  },
  methods: {
    netTypeData() {
      this.$axios.get('/lte/ems/topo/netType').then(response => {
        this.list = response.data.resultVal;
      });
    },

    clickNetType() {
      this.netTypeData();
      this.showNetType = !this.showNetType;
      this.showFirstIcon = !this.showFirstIcon;
    }
  },

  mounted() {
    //this.netTypeData();
  }
};
</script>
<style>
</style>
